module.exports = __webpack_public_path__ + "img/36.2a46bd29.png";